module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn",
    class: [_vm.isBlock ? 'btn-block' : '', _vm.btnTheme, _vm.disabled, _vm.flat, _vm.size, _vm.getAlign],
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.name) + "\n  "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-17f461ff!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VAButton.vue
// module id = 698
// module chunks = 1